export const urls = {
    home: '/',
    license: '/portal/license-overview',
    tenant: '/portal/tenant-settings',
    device: '/portal/device-settings',
    deviceAdd: '/portal/device-settings/:deviceid',
    iqMessenger: '/portal/iqmessenger-settings',
    contact: '/portal/contact-settings',
    contactGroup: '/portal/contactgroup-settings',
    portalAccess: '/portal/portalaccess-settings',
    postLogin: 'post-login-spa'
}